import { useRef } from 'react';
import { ToolRailPortal } from '~/components/toolbar/shared/ToolRailSlots';
import ComparePanel from '~/containers/viewer/compare-panel';
import useWorkflowSteps from '~/containers/viewer/explorer-sidebar/WorkflowStepper/useWorkflowSteps';
import ContourCompareSection from './ContourCompareSection';
import OperationsPanelHandler from './OperationsPanelHandler';
import OperationsSection from './OperationsSection';
import PostProcessingSection from './PostProcessingSection';
import SliceOperationsSection from './SliceOperationsSection';

/**
 * The operations of the Contouring and Review steps: their buttons in the
 * operations group of the step's tool rail, and the panel of the open
 * operation in the tool options dock. The panels render outside the rail
 * portal, so the compare panel lives as long as the Review step.
 */
export default function OperationsToolbar() {
    const { currentStep } = useWorkflowSteps();
    const compareToggleRef = useRef<HTMLElement | null>(null);

    const isContouringStep = currentStep.id === 'contouring';
    const isReviewStep = currentStep.id === 'review';
    if (!isContouringStep && !isReviewStep) {
        return null;
    }

    return (
        <>
            <ToolRailPortal group="ops">
                {isReviewStep && (
                    <ContourCompareSection toggleRef={compareToggleRef} />
                )}
                {isContouringStep && <OperationsSection />}
                <SliceOperationsSection />
                <PostProcessingSection />
            </ToolRailPortal>
            <OperationsPanelHandler />
            {isReviewStep && <ComparePanel toggleRef={compareToggleRef} />}
        </>
    );
}
